export const PROJS_GET_START = 'PROJS_GET_START'
export const PROJS_GET_SUCCESS = 'PROJS_GET_SUCCESS'
export const PROJS_GET_FAIL = 'PROJS_GET_FAIL'
export const PROJS_CLEAR = 'PROJS_CLEAR'
export const PROJS_GET_SAGA = 'PROJS_GET_SAGA'

export const projectsGetStart = () => {
  return {
    type: PROJS_GET_START
  }
}

export const projectsGetSaga = accountId => {
  return {
    type: PROJS_GET_SAGA,
    accountId: accountId
  }
}

export const projectsClear = () => {
  return {
    type: PROJS_CLEAR
  }
}

export const projectsGetSuccess = projects => {
  return {
    type: PROJS_GET_SUCCESS,
    projects: projects
  }
}

export const projectsGetFail = error => {
  return {
    type: PROJS_GET_FAIL,
    error: error
  }
}

